import React from "react";
import "./reusable-components.component.scoped.scss";
import { Box, Typography } from "@material-ui/core";
import TypographiesComponent from "./components/typographies.component";
import ArrowRightIcon from "@material-ui/icons/ArrowRightAlt";
import CheckboxesComponent from "./components/checkboxes.component";
import ButtonsComponent from "./components/buttons.component";
import ColorsComponent from "./components/colors.component";
import FilterChipsComponent from "./components/filter-chips.component";
import SwitchComponent from "./components/switch.component";
import ChipsComponent from "./components/chips.component";

const ReusableComponentsComponent = () => {
  return (
    <Box className="reusable-components-component pb-5">
      <Box className="colors-component">
        <Typography variant="h2" className="title">
          <ArrowRightIcon />
          Colors
        </Typography>
        <ColorsComponent />
      </Box>
      <hr className="my-5" />
      <Box className="typographies-component">
        <Typography variant="h2" className="title">
          <ArrowRightIcon />
          Typographies
        </Typography>
        <TypographiesComponent />
      </Box>
      <hr className="my-5" />
      <Box className="checkboxes-component">
        <Typography variant="h2" className="title">
          <ArrowRightIcon />
          Checkboxes
        </Typography>
        <CheckboxesComponent />
      </Box>
      <hr className="my-5" />
      <Box className="buttons-component">
        <Typography variant="h2" className="title">
          <ArrowRightIcon />
          Buttons
        </Typography>
        <ButtonsComponent />
      </Box>
      <hr className="my-5" />
      <Box className="chips-component">
        <Typography variant="h2" className="title">
          <ArrowRightIcon />
          Chips
        </Typography>
        <ChipsComponent />
      </Box>
      <hr className="my-5" />
      <Box className="filter-chips-component">
        <Typography variant="h2" className="title">
          <ArrowRightIcon />
          Filter Chips
        </Typography>
        <FilterChipsComponent />
      </Box>
      <hr className="my-5" />
      <Box className="switch-component">
        <Typography variant="h2" className="title">
          <ArrowRightIcon />
          Switch
        </Typography>
        <SwitchComponent />
      </Box>
    </Box>
  );
};

export default ReusableComponentsComponent;
